// extracted by mini-css-extract-plugin
export default {"svg":"ImageStepFive_svg__5U5b5"};